import "./App.css";
import React from "react";
import ContactTable from "./components/ContactTable";
import ThemeProvider from "./theme/index";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <ContactTable />
      </ThemeProvider>
    </div>
  );
}

export default App;
